import { msFormVerification } from "../common/constants";

const ConsentAndDisclosureAllOthers = (props) => {
    const {onVerifyClearHandler, displayData} = props;

    return (
        <div className="consent-disclosure">
            <div className="white-box consent-disclosure-all-others">
            <div className="consent-disclosure-description" 
            >
                {displayData[0]?.consent_language}
            </div>
<button 
                className="verify-button"
                id="verify_button_d"
                type="button"
                // onClick={() => window.open(msFormVerification, '_blank', 'noopener,noreferrer')}
                onClick={()=> onVerifyClearHandler(displayData[0]?.consent_id)}
              >
                {
                   displayData[0]?.button_text_inner
                }

              </button>
        </div>
        </div>
    )
}

export default ConsentAndDisclosureAllOthers;